import type { Entity } from "../../entity/index"
import type { PlayerIdOrNull } from "../../player/PlayerIdOrNull"
import type { PlayerGraphNode } from "../PlayerGraphNode/PlayerGraphNode.type"
import type { TileGraphNode } from "../TileGraphNode/TileGraphNode.type"
import type { EntityGraphNode } from "./EntityGraphNode.type"

export default function createDummyEntityGraphNode<T extends Entity>(
  ent: T,
  tile: TileGraphNode,
  player: PlayerGraphNode,
): EntityGraphNode<T> {

  const node = () => ent
  node.id = ent.id
  node.etype_id = ent.etype_id
  node.layer_id = ent.layer_id
  node.tile = tile
  node.player = player
  node.raw = () => ent
  node.color1 = player.color1
  node.color2 = player.color2
  node.player_id = () => ent.player_id as PlayerIdOrNull

  return node
}